<template>
  <div class="container">
    <v-dialog v-model="selectAccountDialog" max-width="400">
        <v-card class="ma-4" max-width="350" v-bind:key="account.id" v-for="account in selectAccountDialogEntries">
            <v-card-title class="text-wrap">
                <p>{{account.name}}</p>
            </v-card-title>
            
            <v-card-subtitle>{{ `ΑΦΜ: ${account.tax_registration_number || '-'}` }}</v-card-subtitle>
            
            <v-card-text>
                <v-container>
                    <v-row>
                        <div>{{account.city}} {{account.zipcode}}</div>
                    </v-row>
                    <v-row>
                        <div>{{account.address}}</div>
                    </v-row>
                    <v-row>
                        <div>{{account.telephone}}</div>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="updateAccount(selectAccountDialogShownFor, account); closeSelectAcountDialog();">ΕΠΙΛΟΓΗ</v-btn>
            </v-card-actions>
        </v-card>
    
    </v-dialog>

    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header>
            Φίλτρα αναζήτησης
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col cols="12" sm="6">
              <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="documentIssueDateStartFilter"
                          label="Ημερομηνία έκδοσης (Από)"
                          append-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          clearable>
                      </v-text-field>
                  </template>
                  <v-date-picker
                      v-model="documentIssueDateStartFilter"
                      @input="menu1 = false">
                  </v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="6">
                <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="documentIssueDateStopFilter"
                            label="Ημερομηνία έκδοσης (Έως)"
                            append-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            clearable>
                        </v-text-field>
                    </template>
                    <v-date-picker
                        v-model="documentIssueDateStopFilter"
                        @input="menu2 = false">
                    </v-date-picker>
                </v-menu>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="6">
                <v-select 
                    v-bind:items="documentTypes" 
                    v-model="documentTypeFilter"
                    return-object
                    
                    item-text="description" 
                    label="Είδος παραστατικού"
                    clearable>
                </v-select>
            </v-col>
            <v-col cols="12" sm="6">
                <v-text-field 
                    v-model="customer.name" 
                    label="Προμηθευτής"
                    append-icon="mdi-account-search"
                    @click:append="searchAccountByName('customer')"
                    @keydown="clearAccount('customer')"
                    v-bind:disabled="customerNotEditable">
                </v-text-field>
            </v-col>
        </v-row>

          <v-row class="my-2" cols="12" align="center" justify="center">
            <v-btn 
                class="mx-2"
                color="success" 
                @click="getData" 
                v-bind:loading="getDataButtonDisabled"
                style="width:120px;">
                <span class="text-truncate" style="width:100px;">ΑΝΑΖΗΤΗΣΗ</span>
            </v-btn>

            <v-btn 
                class="mx-2"
                color="warning" 
                @click="clearFilters" 
                style="width:120px;">
                <span class="text-truncate" style="width:100px;">ΚΑΘΑΡΙΣΜΑ</span>
            </v-btn>

            <!-- <v-btn 
                class="mx-2"
                color="warning" 
                @click="getExcel" 
                v-bind:loading="getExcelButtonDisabled"
                style="width:120px;">
                <span class="text-truncate" style="width:100px;">ΕΞΑΓΩΓΗ</span>
            </v-btn> -->
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>

    <v-data-table
      :headers="headers"
      :items="items"
      :sort-by="['issue_date']"
      :sort-desc="true"
      class="elevation-1 my-2"
      disable-pagination
      disable-filtering
      hide-default-footer>
      
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Παραστατικά εξόδων</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <div>Σύνολο: {{ listItemsSum.toFixed(2) }}</div>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark class="m-2" @click="newDocumentButtonClicked">
            ΝΕΟ
          </v-btn>
          <v-btn color="success" dark class="m-2" @click="excelPlease" v-show="showExport" v-bind:loading="getExcelButtonDisabled">
            ΕΞΑΓΩΓΗ
          </v-btn>

          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5">Διαγραφή εγγραφής {{editedItem.document}};</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary darken-1" text @click="closeDelete">ΑΚΥΡΟ</v-btn>
                <v-btn color="error darken-1" @click="deleteItemConfirm" v-bind:loading="deleteButtonDisabled">ΕΝΤΑΞΕΙ</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogMail" max-width="500px">
            <v-card>
              <v-card-title class="text-h5">Αποστολή email</v-card-title>
              <v-card-text>
                <v-text-field 
                  v-model="editedItem.customer_email"
                  label="Διεύθυνση αποστολής">
                </v-text-field>
                <v-checkbox v-model="saveMailAddress" label="Αποθήκευση διεύθυνσης email"/>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary darken-1" text @click="closeMail">ΑΚΥΡΟ</v-btn>
                <v-btn color="success darken-1" @click="mailConfirm" v-bind:loading="mailButtonDisabled">ΕΝΤΑΞΕΙ</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>


        </v-toolbar>
      </template>
      
      <template v-slot:[`item.issue_date`]="{ item }">
        {{ formatDate(item.issue_date) }}
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small color="primary" @click="sendMail(item)"> mdi-email </v-icon>
        <v-icon small color="primary" @click="show(item)"> mdi-printer </v-icon>
        <router-link :to="{name: 'editservicedocument', params: {id: item.id}}" v-if="false"> 	
          <v-icon small class="mr-2"> mdi-pencil </v-icon>
        </router-link>
        <v-icon small color="error" @click="deleteItem(item)"> mdi-delete </v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import moment from "moment";

  export default {
    data: () => ({
      editedItem: {},
      dialog: false,
      dialogDelete: false,
      dialogMail: false,

      saveMailAddress: false,

      deleteButtonDisabled: false,
      mailButtonDisabled: false,

      headers: [
        { 
            text: 'Actions',
            align: 'center', 
            value: 'actions', 
            sortable: false,
            exportable: false
        },
        {
          text: 'Ημερομηνία',
          align: 'start',
          value: 'issue_date',
          exportTransformer: (cell) => moment(cell).format("DD/MM/YYYY")
        },
        { 
          text: 'Παραστατικό', 
          align: 'center',
          value: 'document' 
        },
        {
          text: 'Προμηθευτής',
          align: 'center',
          value: 'customer',
        },
        { 
          text: 'Καθαρό', 
          align: 'center',
          value: 'net_value',
          exportTransformer: (cell) => cell.replace('.', ',') 
        },
        { 
          text: 'Μικτό', 
          align: 'center',
          value: 'gross_value',
          exportTransformer: (cell) => cell.replace('.', ',')
        },
        
        
      ],

      items: [],

      selectAccountDialog: false,
      selectAccountDialogEntries: [],
      selectAccountDialogShownFor: '',

      documentTypes: [],

      customer: {},
      customerNotEditable: false,

      documentTypeFilter: null,

      documentIssueDateStartFilter: null,
      documentIssueDateStopFilter: null,

      getDataButtonDisabled: false,
      getExcelButtonDisabled: false,

      menu2: null,
      menu1: null,


    }),

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      this.initialize()
    },

    computed: {
      showExport() {
        return this.items?.length > 0
      },

      showListItemsSum() {
        return this.listItemsSum > 0 ? true : false
      },

      listItemsSum() {
        if (this.items?.length > 0 == false)
          return 0
        
        const sum = this.items?.map(x => parseFloat(x.gross_value)).reduce((a, b) => a + b, 0)


        return sum

      },
      
    },

    methods: {

      excelPlease() {
        if (this.items?.length > 0 == false) {
          console.log('No items!')
          return
        }

        const transform = (line, columnDefinitions) => {
          let out = []

          columnDefinitions.forEach(columnDefinition => {

            const columnValue = line[columnDefinition.propertyName]

            if (columnDefinition.exportTransformer)
              out.push(columnDefinition.exportTransformer(columnValue))
            else
              out.push(columnValue)
          });

          return out;
        }

        const exportableColumns = this.headers.filter(x => (x.exportable ?? true) == true)
        const columnDefinitions = exportableColumns.map(x => ({ propertyName: x.value, exportTransformer: x.exportTransformer }))

        const requestBody = {
          table_headers: exportableColumns.map(x => x.text),
          table_entries: this.items.map(line => transform(line, columnDefinitions))
        }

        this.axiosDownload('/api/test', requestBody, 'αναφορά.xls')
      },

      axiosDownload(url, requestBody, filename) {
        this.getExcelButtonDisabled = true;

        axios({
            url: url, 
            data: requestBody,
            method: 'POST',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename); //or any other extension
            document.body.appendChild(link);
            link.click();
            this.getExcelButtonDisabled = false
        // link.remove();
        // url.remove();

        }).catch(err => { console.log(err); this.getExcelButtonDisabled = false})
      },

      newDocumentButtonClicked() {
        this.$router.push({ name: 'newexpense' })
      },

      formatDate(value) {
        return moment(value).format("DD/MM/YYYY")
      },

      mixmatch(customer) {
        customer.country = this.countries.find(country => country.id == customer.country_id)
        customer.taxOffice = this.taxOffices.find(taxOffice => taxOffice.id == customer.tax_registration_office_id )
        
        return customer
      },

      initialize () {
        this.$store.dispatch('currentUser/getCurrentUser')
        
        const initialDaysBeforeFilterValue = 30

        const today = new Date();

        let filterStart = new Date()
        filterStart.setDate(today.getDate() - initialDaysBeforeFilterValue);

        this.documentIssueDateStartFilter = this.$localDateString(filterStart)
        // this.documentIssueDateStopFilter = today.toISOString().split('T')[0]

        this.getData();
        this.getFilterValues()
      },

      getFilterValues() {
        axios.get('/api/document-types/expense')
        .then(response => this.documentTypes = response.data)

      },
      
      getRequestParams() {
        return {
              issue_date_start: this.documentIssueDateStartFilter,
              issue_date_stop: this.documentIssueDateStopFilter,
              document_type_id: this.documentTypeFilter?.id,
              supplier_id: this.customer?.id
          }

      },

      getData() {

        this.getDataButtonDisabled = true;
        axios.get(
            '/api/documents/expenses/grid', 
            {
                params: this.getRequestParams()
            }
        )
        .then(response => this.items = response.data)
        .finally(() => { this.getDataButtonDisabled = false; })
        .catch(error => { console.log(error) })
        
      },

      editItem (item) {
        // this.editedIndex = this.items.indexOf(item)
        // this.editedItem = Object.assign({}, item)
        // this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.deleteButtonDisabled = true
        axios.delete(`/api/documents/expenses/${this.items[this.editedIndex].id}`)
        .then(response => { this.items.splice(this.editedIndex, 1); this.closeDelete(); })
        .catch(error => console.log(error))
        .finally(() => this.deleteButtonDisabled = false)
      },

      mailConfirm() {
        this.mailButtonDisabled = true
        axios
          .post('/api/mailer/expenses', { document_id: this.editedItem.id, email_address: this.editedItem.customer_email, save_email: this.saveMailAddress ? true : false })
          .then(response => { console.log(response); this.closeMail(); })
          .catch(error => { console.log(error) })
          .finally(() => { this.mailButtonDisabled = false })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },


      sendMail(item) {
        this.editedItem = Object.assign({}, item)
        this.dialogMail = true
      },

      show(item) {
        window.open(`/expensedocuments/pdf/${item.uuid}`, '_blank').focus();
      },


      closeMail() {
        this.editedItem = {};
        this.dialogMail = false;
      },

      async searchAccountByName(accountPropertyName) {
            let needle = this[accountPropertyName].name
            let response = await axios.get(`/api/accounts/search/name/${needle}`)

            if (response.data.length == 1)
                this.updateAccount(accountPropertyName, response.data[0])
            else if (response.data.length > 1) {

                this.selectAccountDialogEntries = response.data
                this.selectAccountDialogShownFor = accountPropertyName
                this.selectAccountDialog = true
            }
        },

        updateAccount(accountPropertyName, data) {
            this[accountPropertyName] = {
                id: data.id,
                address : data.address,
                name : data.name,
                city : data.city,
                telephone : data.telephone,
                fax : data.fax,
                email : data.email,
                country_id : data.country_id,
                mobile : data.mobile,
                tax_registration_number: data.tax_registration_number,
                zipcode: data.zipcode,
                tax_registration_office_id: data.tax_registration_office_id,
                jobtitle: data.jobtitle
            }
        },
        
        closeSelectAcountDialog() {
            this.selectAccountDialog = false
            this.selectAccountDialogEntries = []
            this.selectAccountDialogShownFor = null
        },

        clearAccount(accountPropertyName) {
          if (this[accountPropertyName]?.id > 0)
            this[accountPropertyName].id = null
        },

        clearFilters() {
          this.customer = {}
          this.documentIssueDateStartFilter = null
          this.documentIssueDateStopFilter = null
          this.documentTypeFilter = null
        }
    }
  }
</script>

<style scoped>
</style>